module.exports = __webpack_public_path__ + "static/media/spiraal.dfe1d162.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/spiraal.gif
// module id = 499
// module chunks = 0